export default "__VITE_ASSET__f2edd453__"